"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNcsbnProfileDto = instanceOfNcsbnProfileDto;
exports.NcsbnProfileDtoFromJSON = NcsbnProfileDtoFromJSON;
exports.NcsbnProfileDtoFromJSONTyped = NcsbnProfileDtoFromJSONTyped;
exports.NcsbnProfileDtoToJSON = NcsbnProfileDtoToJSON;
exports.NcsbnProfileDtoToJSONTyped = NcsbnProfileDtoToJSONTyped;
/**
 * Check if a given object implements the NcsbnProfileDto interface.
 */
function instanceOfNcsbnProfileDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('ncsbnId' in value) || value['ncsbnId'] === undefined)
        return false;
    return true;
}
function NcsbnProfileDtoFromJSON(json) {
    return NcsbnProfileDtoFromJSONTyped(json, false);
}
function NcsbnProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'ncsbnId': json['ncsbnId'],
    };
}
function NcsbnProfileDtoToJSON(json) {
    return NcsbnProfileDtoToJSONTyped(json, false);
}
function NcsbnProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'ncsbnId': value['ncsbnId'],
    };
}
//# sourceMappingURL=NcsbnProfileDto.js.map